import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ajax-loader"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "scroll-top grid-listing"
}
const _hoisted_4 = { class: "flex-container" }
const _hoisted_5 = { class: "right-container-nav" }
const _hoisted_6 = { class: "width25" }
const _hoisted_7 = { class: "width50" }
const _hoisted_8 = { class: "main-heading primary-heading" }
const _hoisted_9 = { class: "add-btn-position" }
const _hoisted_10 = {
  key: 0,
  class: "padding-top-20"
}
const _hoisted_11 = { class: "top-margin-in-fields" }
const _hoisted_12 = { class: "filter-sub-heading" }
const _hoisted_13 = { for: "Filter" }
const _hoisted_14 = { class: "color-red" }
const _hoisted_15 = { class: "font-size-16 margin-top-30" }
const _hoisted_16 = { class: "color-red" }
const _hoisted_17 = { class: "filter-count-container" }
const _hoisted_18 = { for: "Filter" }
const _hoisted_19 = { class: "top-margin-in-fields" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "top-margin-in-fields" }
const _hoisted_22 = { for: "Filter" }
const _hoisted_23 = { value: 0 }
const _hoisted_24 = ["value", "selected"]
const _hoisted_25 = { class: "top-margin-in-fields" }
const _hoisted_26 = { for: "Filter" }
const _hoisted_27 = { class: "segment-filter-parent" }
const _hoisted_28 = { class: "segment-filter" }
const _hoisted_29 = { value: 0 }
const _hoisted_30 = ["value", "selected"]
const _hoisted_31 = { class: "segment-filter" }
const _hoisted_32 = { value: 0 }
const _hoisted_33 = ["value", "selected"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "margin-right-5 hyper-link" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "margin-right-5 hyper-link" }
const _hoisted_39 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationSummary = _resolveComponent("ValidationSummary")!
  const _component_InputControlCheckBox = _resolveComponent("InputControlCheckBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.localNotificationLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            class: "img-responsive ajax-loader-img",
            src: _ctx.loadingImage,
            alt: "Wait"
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.localNotificationLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn btn-secondary btn-size-default",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CloseCreateFilter()))
                }, _toDisplayString(_ctx.$t("Button.Close")), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Dialogue.Filter.Heading")), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-primary btn-size-default",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SaveFilter(_ctx.v$)))
                }, _toDisplayString(_ctx.$t("Dialogue.Save")), 1)
              ])
            ]),
            (_ctx.visibleValidationSummary)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_ValidationSummary, {
                    "error-fields": _ctx.validationErrorFields,
                    onCloseClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CloseValidationSummary($event)))
                  }, null, 8, ["error-fields"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("Dialogue.Filter.SubHeading")), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.$t("Dialogue.Filter.FilterName")), 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("Asteric")), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.filterTitle.$model) = $event)),
                type: "text",
                class: "form-control font-weight-600",
                maxlength: "100"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.v$.filterTitle.$model,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("label", _hoisted_15, [
                _createTextVNode(_toDisplayString(_ctx.$t("Dialogue.Filter.FilterSettings")), 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("Asteric")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("Dialogue.Filter.ChooseGroup")), 1),
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("Dialogue.Filter.YourFilter", {participantCount : _ctx.participantCount})), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _createVNode(_component_InputControlCheckBox, {
                  "input-data": _ctx.inputControlData,
                  onCheckedItems: _ctx.SetSelectedParticipantGroupIds
                }, null, 8, ["input-data", "onCheckedItems"])
              ])
            ]),
            (_ctx.showMoreFilterOptions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("Dialogue.Filter.ParticipantInterest")), 1),
                    _createElementVNode("select", {
                      id: "selInterest",
                      class: "form-control selectBox",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ChangeParticipantInterest($event)))
                    }, [
                      _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t("Dialogue.Filter.ChooseInterest")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableInterests, (interest, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: index,
                          value: interest.Id,
                          selected: interest.Id === _ctx.seletedParticipantInterestId
                        }, _toDisplayString(interest.Name), 9, _hoisted_24))
                      }), 128))
                    ], 32)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("Dialogue.Filter.SegmentCriteria")), 1),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("select", {
                          id: "selInterest",
                          class: "form-control selectBox",
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.FilterSegmentChoices($event, true)))
                        }, [
                          _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t("Dialogue.Filter.ChooseSegment")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableSegments, (segments, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: segments.Id,
                              selected: segments.Id === _ctx.seletedSegmentQuestionId
                            }, _toDisplayString(segments.Name), 9, _hoisted_30))
                          }), 128))
                        ], 32)
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mid-segment-filter" }, " = ", -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("select", {
                          id: "selInterest",
                          class: "form-control selectBox",
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ChangeSegmentChoices($event)))
                        }, [
                          _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t("Dialogue.Filter.SegmentChoice")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSegmentsChoices, (segmentchoice, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: index,
                              value: segmentchoice.ChoiceId,
                              selected: segmentchoice.ChoiceId === _ctx.seletedSegmentChoiceId
                            }, _toDisplayString(segmentchoice.ChoiceText), 9, _hoisted_33))
                          }), 128))
                        ], 32)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createElementVNode("label", {
                class: "inline-flex show-hide-table-label cursor-pointer margin-top-20",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.ShowMoreOptions && _ctx.ShowMoreOptions(...args)))
              }, [
                (_ctx.isArrowUp)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("a", _hoisted_35, _toDisplayString(_ctx.$t("Dialogue.Filter.LessOptions")), 1),
                      _createElementVNode("img", {
                        src: _ctx.arrowUpIcon,
                        alt: "show"
                      }, null, 8, _hoisted_36)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("a", _hoisted_38, _toDisplayString(_ctx.$t("Dialogue.Filter.MoreOptions")), 1),
                      _createElementVNode("img", {
                        src: _ctx.arrowDownIcon,
                        alt: "hide"
                      }, null, 8, _hoisted_39)
                    ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}